export default function getResource(label) {
    const resources = {
        pointsAvailable: points => `${points} points available`,
        appliedMessage: (applied, remaining) => `${applied} applied • ${remaining} left to redeem`
    };
    return resources[label];
}
